import equal from 'fast-deep-equal';
import structuredClone from '@ungap/structured-clone';
import cloneDeep from 'lodash.clonedeep';
//var eql = require("deep-eql");

export function sClone(a) {
  return structuredClone(
    a,
    {
      lossy: true,
      json: true
    }
  );
}

export function lodashClonedeep(a) {
  return cloneDeep(a);
}

export function deepClone(a) {
  return JSON.parse(JSON.stringify(a));
}

export function isJSONequal(a, b) {
  return JSON.stringify(a).localeCompare(JSON.stringify(b), 'de-DE') === 0 ? true : false;
}
export function deepEqual(a, b) {
  return equal(JSON.parse(JSON.stringify(a)), JSON.parse(JSON.stringify(b)));
};

export function getPosition(el) {
  const btnRect = el.getBoundingClientRect();
  const qDialog = document.querySelector('.tables-dialog');
  const qDialogRect = qDialog.getBoundingClientRect();
  const windowBottom = window.scrollY + window.innerHeight;
  const windowBottomHalf = windowBottom / 2.0;
  const windowLeftHalf = window.innerWidth / 2.0;
  return { x: btnRect.left < windowLeftHalf ? btnRect.left + 16: btnRect.left - (qDialogRect.width + 16), y: btnRect.top < windowBottomHalf ? btnRect.top +16 : btnRect.top - (qDialogRect.height + 16) }
}


export function debounce(fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

export function renderTableitems(key,newVal, oldVal) {
  newVal[key] = true;
  const oldTrueKeys = Object.keys(oldVal).filter(key => oldVal[key]);
  const newTrueKeys = Object.keys(newVal).filter(key => newVal[key]);
  const difference = newTrueKeys.filter(x => !oldTrueKeys.includes(x));

  if (difference.length === 1) {
    const newKey = difference[0];
    Object.keys(newVal).forEach(key => {
      newVal[key] = false;
    });
    newVal[newKey] = true;
  }

  return newVal;
}


export function isDeepEqual(obj1, obj2) {
  const objKeys1 = Object.keys(obj1);
  const objKeys2 = Object.keys(obj2);

  if (objKeys1.length !== objKeys2.length) return false;

  for (var key of objKeys1) {
    const value1 = obj1[key];
    const value2 = obj2[key];

    const isObjects = isObject(value1) && isObject(value2);

    if ((isObjects && !isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
      return false;
    }
  }
  return true;
}

const isObject = (object) => {
  return object != null && typeof object === "object";
}

export function markItem(items = [], id = null, key = null, multiple = false){
  const length = items.length - 1;
  for(let i = 0; i <= length; i++){
    if(key === null){
      if(multiple && items[i]['marked'] === true) continue;
      items[i]['marked'] = items[i].id === id;
    }else{
      if(multiple && items[i][key]['marked'] === true) continue;
      items[i][key]['marked'] = items[i][key].id === id;
    }
  }
}

export function getAllValues(values = []){
  const out = [];
  const length = values.length - 1;
  for(let i = 0; i <= length; i++){
    if(typeof values[i]['value'] != 'undefined'){
      out[out.length] = values[i].value;
    }else if(typeof values[i]['short'] != 'undefined'){
      out[out.length] = values[i].short;
    }
  }
  return out;
}

export function openItem(route,id,target = '_blank'){
  let publicPath = process.env.PUBLIC_PATH.endsWith('/') ? process.env.PUBLIC_PATH.slice(0, -1) : process.env.PUBLIC_PATH;
  const base = process.env.PROD ? publicPath : `${window.location.origin}/#`;
  const newTab = window.open(`${base}${route}?id=${id}`, target);
}

export function existUnSavedOrderChanges(){
  return localStorage.getItem('orderChanges') == 'true' && localStorage.getItem('savingOrder') == 'false';
}
